import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Special Tax Items';

export const SpecialTaxRoutes = [
  {
    path: '/tax/specialTaxItems',
    name: 'Tax- Special Tax Items',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/SpecialTaxItems.vue'),
    children: [
      {
        path: 'protestedTax',
        name: 'Tax - Protested Tax',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/specialTax/ProtestedTax.vue'),
      },
      {
        path: 'exemptMfg',
        name: 'Tax - Exempt Manufacturing',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/specialTax/ExemptMfg.vue'),
      },
      {
        path: 'tifDistricts',
        name: 'Tax - TIF Districts',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/specialTax/TifDistricts.vue'),
      },
      {
        path: 'newTaxRoll',
        name: 'Tax - New Tax Roll',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/specialTax/newTaxRoll/NewTaxRoll.vue'),
        children: [
          {
            path: 'importandbalance',
            name: 'Tax - New Tax Roll - Import & Balance',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/specialTax/newTaxRoll/ImportAndBalance.vue'),
          },
          {
            path: 'assessorxref',
            name: 'Tax - New Tax Roll - Assessor X-Ref',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/specialTax/newTaxRoll/AssessorXRef.vue'),
          },
          {
            path: 'mergeandfinalize',
            name: 'Tax - New Tax Roll - Merge & Finalize',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/specialTax/newTaxRoll/MergeAndFinalize.vue'),
          },
          {
            path: 'assessorfiretaxxref',
            name: 'Tax - New Tax Roll - Fire Tax X-Ref',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/specialTax/newTaxRoll/AssessorFireTaxXRef.vue'),
          },
        ],
      },
    ],
  },
];

// which roles have to define need to know
SpecialTaxRoutes.forEach((element, index) => {
  SpecialTaxRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.SpecialTaxAuth], next);
  };
});

export default SpecialTaxRoutes;
